import { defineStore } from 'pinia'
import { IAuthStore } from 'src/system/core/model/auth/IAuthStore'

const defaultState: IAuthStore = {
  userId: null,
  tokenType: null,
  expiresIn: null,
  accessToken: null,
  refreshToken: null,
  clear: () => {},
}

export const useAuthStore = defineStore('auth', {
  state: (): IAuthStore => ({ ...defaultState }),
  getters: {
    isLoggedIn: (state) => !!state.accessToken,
  },
  actions: {
    logout() {
      Object.assign(this, defaultState)
    },
    clear() {
      this.userId = null
      this.tokenType = null
      this.expiresIn = null
      this.accessToken = null
      this.refreshToken = null
    },
  },
  persist: {
    enabled: true,
  },
})
